import {
  NEW_NAUTICAL_APPLICATION_CHART,
  RESIGN_NAUTICAL,
  ISSUE_COPY_NAUTICAL,
} from "../constants";

// Set the docs with particular order based on requirements they send us
export const sortOrderDocs = (docs, applicationId) => {
  let appl_kind_id;

  // Checks if docs table has appl_kind_id field if not we get it from the parameters
  if (docs?.[0]) {
    if (Object.keys(docs[0])?.find((item) => item === "appl_kind_id")) {
      appl_kind_id = docs[0]?.appl_kind_id;
    } else {
      appl_kind_id = applicationId;
    }
  }

  const getOnlyTheSortOrderWeNeedForApplKindId = docs?.map((doc) => {
    const {
      order_ekdosi_nautikou_filadiou,
      order_ekdosi_antrigrafou_nautikou_filadiou,
      order_epanipografi_nautikou_filadiou,
      ...rest
    } = doc;

    if (appl_kind_id === NEW_NAUTICAL_APPLICATION_CHART) {
      return { ...rest, sortOrder: order_ekdosi_nautikou_filadiou };
    } else if (appl_kind_id === ISSUE_COPY_NAUTICAL) {
      return { ...rest, sortOrder: order_ekdosi_antrigrafou_nautikou_filadiou };
    } else if (appl_kind_id === RESIGN_NAUTICAL) {
      return { ...rest, sortOrder: order_epanipografi_nautikou_filadiou };
    } else {
      return { ...doc };
    }
  });

  const filteredWithNullOrder = getOnlyTheSortOrderWeNeedForApplKindId?.filter(
    (a) => a.sortOrder === null
  );

  const sortedWithoutNullsortOrder = getOnlyTheSortOrderWeNeedForApplKindId
    ?.filter((a) => a.sortOrder !== null)
    ?.sort((a, b) => {
      return a.sortOrder - b.sortOrder;
    });

  if (
    filteredWithNullOrder !== undefined &&
    sortedWithoutNullsortOrder !== undefined
  ) {
    return [...sortedWithoutNullsortOrder, ...filteredWithNullOrder];
  }
};
